import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HttpConfig } from './configs/http.config';
import { ToastComponent } from './shareds/toast/toast.component';
import { LoadingComponent } from './shareds/loading/loading.component';
import { SimpleLayoutModule } from './layouts/simple-layout/simple-layout.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { UploadFileComponent } from './shareds/upload-file/upload-file.component';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { TableModule } from 'primeng/table';
import { PaginationComponent } from './shareds/pagination/pagination.component';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { UiComponent } from './shareds/ui/ui.component';
import { CheckComponent } from './pages/check/check.component';
import { ApiComponent } from './pages/api/api.component';
import { TotalstringPipe } from './pipe/totalstring.pipe';
import { FixnumberPipe } from './pipe/fixnumber.pipe';
import { KeyapiComponent } from './pages/keyapi/keyapi.component';
import { CalendarModule } from 'primeng/calendar';
import { TranslatePipe } from './pipe/translate.pipe';
import { LoadingService } from './services/loading.service';
import { RankComponent } from './pages/rank/rank.component';
import { MemberComponent } from './pages/member/member.component';
import { RateComponent } from './pages/rate/rate.component';
import { PointComponent } from './pages/point/point.component';
import { RewardsComponent } from './pages/rewards/rewards.component';
import { GiftVoucherComponent } from './pages/gift-voucher/gift-voucher.component';
import { EventComponent } from './pages/event/event.component';
import { SecretComponent } from './pages/secret/secret.component';
import { ServerIpComponent } from './pages/server-ip/server-ip.component';
import { TransactionComponent } from './pages/transaction/transaction.component';
import { RedeemComponent } from './pages/redeem/redeem.component';
import { ItemRewardBoxComponent } from './pages/item-reward-box/item-reward-box.component';
import { SettingMarketComponent } from './pages/setting-market/setting-market.component';
import { CodeUsedComponent } from './pages/code-used/code-used.component';
import { CouponComponent } from './pages/coupon/coupon.component';
import { SendGiftVoucherComponent } from './pages/gift-voucher/send-gift-voucher/send-gift-voucher.component';
import { DeductComponent } from './pages/deduct/deduct.component';
import { MenuModule } from 'primeng/menu';
import { CheckboxComponent } from './shareds/checkbox/checkbox.component';
import { FilterComponent } from './shareds/filter/filter.component';
import { GetLinkComponent } from './pages/get-link/get-link.component';
import { QRCodeModule } from 'angularx-qrcode';
import { DashboardComponent } from './pages/dashboard/dashboard.component';


function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: {
        url: 'https://api-dev.legitid.org/auth/',
        realm: 'Avesta',
        clientId: 'CRM',
        // clientId: 'bookingX',

      },
      initOptions: {
        onLoad: 'login-required',  // allowed values 'login-required', 'check-sso';
        // flow: "standard"          // allowed values 'standard', 'implicit', 'hybrid';
      },
    });
}

@NgModule({
  declarations: [
    AppComponent,
    UploadFileComponent,
    PaginationComponent,
    UiComponent,
    CheckComponent,
    ApiComponent,
    TotalstringPipe,
    FixnumberPipe,
    KeyapiComponent,
    RankComponent,
    MemberComponent,
    RateComponent,
    PointComponent,
    RewardsComponent,
    GiftVoucherComponent,
    EventComponent,
    SecretComponent,
    ServerIpComponent,
    TransactionComponent,
    RedeemComponent,
    ItemRewardBoxComponent,
    SettingMarketComponent,
    CodeUsedComponent,
    CouponComponent,
    SendGiftVoucherComponent,
    DeductComponent,
    CheckboxComponent,
    FilterComponent,
    GetLinkComponent,
    DashboardComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    LoadingComponent,
    ToastComponent,
    SimpleLayoutModule,
    KeycloakAngularModule,
    DialogModule,
    ButtonModule,
    DropdownModule,
    InputTextModule,
    MessagesModule,
    MessageModule,
    TableModule,
    ToastModule,
    CalendarModule,
    MenuModule,
    QRCodeModule
  ],

  providers: [
    LoadingService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpConfig, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService],
    },
    MessageService

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
